module.exports = __webpack_public_path__ + "img/congress.5c3d8e35.png";